import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ 
  selectedCount = 0, 
  onBulkDelete, 
  onBulkAssign, 
  onClearSelection,
  employees = []
}) => {
  const [showAssignMenu, setShowAssignMenu] = useState(false);

  if (selectedCount === 0) return null;

  const handleBulkAssign = (employeeIds) => {
    onBulkAssign(employeeIds);
    setShowAssignMenu(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-floating animate-slide-in-left">
      <div className="bg-card border border-border rounded-lg shadow-elevation-4 p-4 min-w-80">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <span className="text-primary-foreground text-sm font-medium">
                {selectedCount}
              </span>
            </div>
            <span className="text-sm font-medium text-foreground">
              {selectedCount} خدمت انتخاب شده
            </span>
          </div>

          <Button
            variant="ghost"
            size="icon"
            onClick={onClearSelection}
            iconName="X"
            iconSize={16}
            className="text-muted-foreground hover:text-foreground"
          >
            <span className="sr-only">لغو انتخاب</span>
          </Button>
        </div>

        <div className="flex items-center gap-2 mt-4">
          {/* Bulk Assign */}
          <div className="relative">
            <Button
              variant="outline"
              onClick={() => setShowAssignMenu(!showAssignMenu)}
              iconName="Users"
              iconPosition="left"
              className="text-sm"
            >
              تخصیص گروهی
              <Icon 
                name="ChevronDown" 
                size={14} 
                className={`mr-1 transition-transform ${showAssignMenu ? 'rotate-180' : ''}`}
              />
            </Button>

            {/* Assignment Menu */}
            {showAssignMenu && (
              <div className="absolute bottom-full left-0 mb-2 w-64 bg-popover border border-border rounded-lg shadow-elevation-3 animate-fade-in">
                <div className="p-3">
                  <h4 className="text-sm font-medium text-foreground mb-3">
                    انتخاب کارکنان برای تخصیص
                  </h4>
                  
                  {employees?.length > 0 ? (
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {employees?.map((employee) => (
                        <label
                          key={employee?.id}
                          className="flex items-center gap-2 cursor-pointer hover:bg-muted/50 p-2 rounded-md transition-colors"
                        >
                          <input
                            type="checkbox"
                            className="w-4 h-4 text-primary bg-background border-border rounded focus:ring-primary focus:ring-2"
                          />
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center">
                              <Icon name="User" size={12} className="text-primary" />
                            </div>
                            <span className="text-sm text-foreground">{employee?.name}</span>
                          </div>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm text-muted-foreground text-center py-4">
                      هیچ کارمندی یافت نشد
                    </p>
                  )}
                  
                  <div className="flex items-center gap-2 mt-3 pt-3 border-t border-border">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setShowAssignMenu(false)}
                      className="flex-1"
                    >
                      انصراف
                    </Button>
                    <Button
                      size="sm"
                      onClick={() => handleBulkAssign([])}
                      className="flex-1"
                    >
                      تخصیص
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Bulk Delete */}
          <Button
            variant="destructive"
            onClick={onBulkDelete}
            iconName="Trash2"
            iconPosition="left"
            className="text-sm"
          >
            حذف گروهی
          </Button>
        </div>
      </div>
      {/* Backdrop for assignment menu */}
      {showAssignMenu && (
        <div 
          className="fixed inset-0 z-[-1]" 
          onClick={() => setShowAssignMenu(false)}
        />
      )}
    </div>
  );
};

export default BulkActionsBar;